// 翻译字典
const translations = {
  zh: {
    // 通用
    darkMode: '深色模式',
    lightMode: '浅色模式',
    chinese: '中文',
    english: 'English',
    swipeToSee: '← 左右滑动查看更多 →',
    brandName: '奇迹妙审',
    
    // 页面标题
    dashboard: '管理后台',
    userCenter: '管理中心',
    beta: 'Beta',
    
    // 侧边栏菜单
    home: '首页',
    cloak: '奇迹妙审',
    cloakList: '斗篷列表',
    cloakLogs: '斗篷日志',
    myPlans: '我的套餐',
    planPurchase: '套餐购买',

    // 套餐购买页面
    purchaseSubtitle: '按真实链接访问次数计费，购买即充入账户',
    recommended: '推荐',
    validPeriod: '有效期',
    avgPrice: '平均',
    perCall: '次',
    realLinkCalls: '真实链接访问次数',
    globalGeoTargeting: '全球地理定向',
    basicGeoTargeting: '基础地理定向',
    uaInterception: 'UA识别拦截',
    accessLogDays: '访问日志{days}天',
    accessLogDaysUnlimited: '访问日志永久',
    unlimitedCloaks: '无限斗篷数量',
    maxCloaksText: '最多{count}个斗篷',
    apiAccess: 'API接入',
    noApiAccess: '✗ API接入',
    unlimitedSubAccounts: '无限子账号+专属客服',
    subAccountsCount: '{count}个子账号',
    noSubAccounts: '✗ 子账号',
    buyNow: '立即购买',
    paymentMethods: '支付方式：',
    creditCard: '信用卡 / Stripe',
    bankTransfer: '银行电汇',
    paymentNote: '说明：',
    paymentDescription: ' 套餐次数购买后即充入账户，按实际使用消耗，有效期内未用完次数自动清零，不支持退款。',
    loadPlansFailed: '加载套餐失败',
    
    // 管理员菜单
    adminPanel: '管理面板',
    adminDashboard: '仪表盘',
    userManagement: '用户管理',
    paymentReview: '支付审核',
    planManagement: '套餐管理',
    siteSettings: '网站设置',
    statistics: '数据统计',
    
    // 管理员仪表盘统计
    userStats: '用户统计',
    paymentStats: '支付统计',
    planStats: '套餐统计',
    cloakStats: '斗篷统计',
    activeUsers: '活跃用户',
    memberUsers: '会员用户',
    pendingPayments: '待处理',
    approvedPayments: '已通过',
    rejectedPayments: '已拒绝',
    activePlans: '激活套餐',
    recentUsers: '最近注册用户',
    recentPayments: '最近支付记录',
    viewAll: '查看全部',
    
    // 用户管理界面
    userList: '用户列表',
    addUser: '添加用户',
    addAdmin: '添加管理员',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    userId: '用户ID',
    username: '用户名',
    email: '邮箱',
    userRole: '用户角色',
    status: '状态',
    isMemberValid: '会员有效',
    membershipExpiry: '会员到期',
    userTotalCalls: '累计调用次数',
    userRemainingCalls: '剩余调用次数',
    deactivate: '禁用',
    activate: '激活',
    invalid: '无效',
    valid: '有效',
    createdAt: '创建时间',
    lastLogin: '最后登录',
    actions: '操作',
    search: '搜索',
    reset: '重置',
    filter: '筛选',
    active: '活跃',
    inactive: '禁用',
    all: '全部',
    confirmDelete: '确认删除',
    deleteConfirmation: '确定要删除这个用户吗？此操作不可撤销。',
    cancel: '取消',
    confirm: '确认',
    roleAdmin: '管理员',
    roleUser: '用户',
    roleVip: 'VIP用户',
    roleSuperAdmin: '超级管理员',
    
    // 提升为管理员
    promoteToAdmin: '设为管理员',
    confirmPromoteToAdmin: '确认设为管理员',
    promote: '提升',
    createAdmin: '创建管理员',
    activateSuccess: '用户激活成功',
    activateFailed: '激活用户失败',
    deactivateFailed: '禁用用户失败',
    confirmDeactivate: '确认禁用用户',
    deactivateConfirmation: '确定要禁用用户 {0} 吗？禁用后该用户将无法登录。',
    
    // 支付审核界面
    paymentReview: '支付审核',
    paymentRecords: '支付记录',
    paymentDetails: '支付详情',
    orderId: '订单号',
    userId: '用户ID',
    planName: '套餐名称',
    amount: '金额',
    totalCalls: '调用次数',
    validityDays: '有效期',
    days: '天',
    submittedAt: '提交时间',
    updatedAt: '更新时间',
    updated: '更新时间',
    paymentId: '订单号',
    approvePayment: '审核通过',
    rejectPayment: '拒绝',
    confirmApprove: '确认通过',
    confirmReject: '确认拒绝',
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝',
    rejectReason: '拒绝原因',
    rejectReasonRequired: '请输入拒绝原因',
    enterRejectReason: '请输入拒绝原因...',
    noRemark: '无备注',
    remark: '备注',
    paymentScreenshot: '支付截图',
    noScreenshot: '无截图',
    dateFrom: '开始日期',
    dateTo: '结束日期',
    perPage: '每页显示',
    noPayments: '暂无支付记录',
    unknownPlan: '未知套餐',
    operationFailed: '操作失败，请重试',
    retry: '重试',
    details: '详情',
    
    // 支付审核确认和结果提示
    approveConfirmationMessage: '你确定要通过这笔支付吗？用户的会员权限将会被激活。',
    rejectConfirmationMessage: '你确定要拒绝这笔支付吗？请确保已经填写了拒绝理由。',
    approveSuccess: '支付已成功通过审核',
    rejectSuccess: '支付已被拒绝',
    approveFailure: '通过审核失败',
    rejectFailure: '拒绝支付失败',
    
    requiredField: '此字段为必填项',
    passwordTooShort: '密码至少需要8个字符',
    invalidEmail: '请输入有效的邮箱地址',
    saveChanges: '保存更改',
    createUser: '创建用户',
    delete: '删除',
    edit: '编辑',
    processing: '处理中...',
    leaveEmptyToKeep: '留空保持不变',
    noUsers: '暂无用户数据',
    
    // 用户套餐详情弹窗
    planUsageDetail: '套餐使用详情',
    currentPlanName: '当前套餐',
    memberStatus: '会员状态',
    memberValid: '有效',
    memberExpired: '已过期',
    notMember: '非会员',
    membershipStartDate: '开通时间',
    membershipExpiryDate: '到期时间',
    remainingDays: '剩余天数',
    daysUnit: '天',
    totalCallsLabel: '总调用次数',
    remainingCallsLabel: '剩余调用次数',
    usedCallsLabel: '已使用次数',
    usageRate: '使用率',
    adjustPlan: '调整套餐',
    adjustCalls: '调整次数',
    adjustDays: '调整天数',
    adjustCallsPlaceholder: '正数增加，负数减少',
    adjustDaysPlaceholder: '正数延长，负数缩短',
    applyAdjustment: '应用调整',
    adjustSuccess: '调整成功',
    adjustFailed: '调整失败',
    paymentHistory: '支付记录',
    noPaymentHistory: '暂无支付记录',
    paymentAmount: '支付金额',
    paymentStatus: '支付状态',
    paymentDate: '支付时间',
    close: '关闭',
    timesUnit: '次',
    noPlanAssigned: '未分配套餐',
    notAvailable: '无',
    expired: '已过期',
    callsUsageProgress: '次数使用进度',
    adjustRequiresMember: '该用户非会员，无法手动调整套餐。请先通过支付审核为其开通会员。',
    
    // 套餐管理界面
    planManagement: '套餐管理',
    planList: '套餐列表',
    planId: '套餐ID',
    chineseName: '中文名称',
    englishName: '英文名称',
    planNameChinese: '套餐名称(中文)',
    enterPlanNameChinese: '输入中文套餐名称',
    planNameEnglish: '套餐名称(英文)',
    enterPlanNameEnglish: '输入英文套餐名称',
    planSavedSuccess: '套餐保存成功',
    price: '价格',
    addPlan: '添加套餐',
    editPlan: '编辑套餐',
    createPlan: '创建套餐',
    save: '保存',
    mustBePositive: '必须是正数',
    enterPlanName: '请输入套餐名称',
    deletePlanConfirmation: '确定要删除这个套餐吗？此操作不可撤销。',
    noPlans: '暂无套餐数据',
    
    // 随机周期相关
    randomPeriod: '随机周期',
    enableRandomPeriod: '启用随机周期',
    validityDaysMin: '最小天数',
    validityDaysMax: '最大天数',
    randomPeriodRange: '随机周期范围',
    specifyValidityDays: '指定有效天数',
    validityDaysPlaceholder: '请输入有效天数',
    randomPeriodHint: '该套餐启用了随机周期，审核时需指定有效天数',
    validityDaysRangeHint: '范围: {min}-{max} 天',
    adminSpecifiedDays: '管理员指定天数',
    randomPeriodLabel: '随机周期',
    fixedPeriodLabel: '固定周期',
    minDaysRequired: '最小天数为必填项',
    maxDaysRequired: '最大天数为必填项',
    minMaxError: '最小天数不能大于最大天数',
    validityDaysRequired: '请指定有效天数',
    validityDaysOutOfRange: '有效天数必须在 {min}-{max} 天之间',
    unlimitedCalls: '无限次数',
    enableUnlimitedCalls: '无限调用次数',
    unlimited: '无限',
    setUnlimitedCalls: '不限次数',
    confirmSetUnlimitedCalls: '确认设置不限次数',
    setUnlimitedCallsConfirmation: '确定要将用户 {0} 设置为不限调用次数吗？设置后该用户将不受调用次数限制。',
    unlimitedCallsSetSuccess: '已成功设置为不限次数',
    unlimitedCallsSetFailed: '设置不限次数失败',
    cancelUnlimitedCalls: '取消不限次数',
    
    // 套餐状态相关
    planStatus: '套餐状态',
    statusActive: '上架',
    statusInactive: '下架',
    enablePlan: '上架',
    disablePlan: '下架',
    
    // 用户菜单
    profile: '个人资料',
    settings: '账户设置',
    logout: '退出登录',
    user: '用户',
    
    // 卡片标题
    cloakOverview: '斗篷总览',
    logRecords: '日志记录',
    mySubscription: '我的套餐',
    recentActivity: '最近活动',
    quickActions: '快速操作',
    
    // 统计数据标签
    totalCloaks: '总斗篷数',
    activeCloaks: '活跃斗篷',
    totalLogs: '总日志数',
    currentPlan: '当前套餐',
    expiryDate: '到期时间',
    noPlan: '无套餐',
    
    // 活动表格
    time: '时间',
    action: '操作',
    status: '状态',
    details: '详情',
    success: '成功',
    noActivity: '暂无活动记录',
    
    // 按钮
    createNewCloak: '创建新斗篷',
    viewAllLogs: '查看所有日志',
    upgradePlan: '升级套餐',
    
    // 版权信息
    copyright: '© {year} 奇迹妙审',
    tagline: '专业斗篷投放系统',

    // 仪表盘首页
    dashboardSubtitle: '欢迎回来，查看您的数据概览',
    totalCloaksSub: '今日新增 +{0}',
    totalLogsSub: '累计访问日志',
    recentCloaks: '最近斗篷',
    mode: '模式',
    name: '名称',
    shortLink: '短链接',
    targetUrl: '目标链接',
    visits: '访问次数',
    created: '创建时间',
    createdAt: '创建时间',
    noRecentCloaks: '暂无斗篷数据',
    copyLink: '复制链接',
    loading: '加载中...',
    error: '错误',
    reload: '重新加载',
    remainingCalls: '剩余次数',
    unlimited: '不限',
    viewAllCloaks: '查看全部斗篷 →',
    linkCopied: '链接已复制到剪贴板',
    copyFailed: '复制失败',
    copyFailedManual: '复制失败，请手动复制',
    premiumMember: '高级会员',
    freeUser: '免费用户',
    failedToLoadData: '获取数据失败',
    failedToLoadDataRetry: '获取数据失败，请稍后再试',

    // 登录注册页面
    login: '登录',
    register: '注册',
    emailAddress: '邮箱地址',
    password: '密码',
    forgotPassword: '忘记密码?',
    rememberMe: '记住我',
    verificationCode: '验证码',
    sendCode: '发送验证码',
    resendCodeIn: '{seconds}秒后重发',
    passwordPlaceholder: '请输入密码',
    passwordRule: '至少8位，包含字母和数字',
    codePlaceholder: '请输入6位验证码',
    sending: '发送中',
    processing: '处理中...',
    agreeTerms: '我已阅读并同意',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    and: '和',
    welcomeBack: '欢迎回来',
    loginToContinue: '登录以继续使用您的账户',
    noAccount: '还没有账户?',
    hasAccount: '已有账户?',
    createAccount: '创建新账户',
    registerToContinue: '注册以开始使用我们的服务',
    switchToLogin: '返回登录',
    switchToRegister: '立即注册',
    requiredEmail: '请输入邮箱地址',
    requiredPassword: '请输入密码',
    invalidPassword: '密码至少需要8位，且包含字母和数字',
    requiredCode: '请输入验证码',
    invalidCode: '验证码应为6位数字',
    agreeTermsError: '请同意服务条款',
    resetPassword: '重置密码',
    resetPasswordSent: '重置密码链接已发送到 {email}',
    verificationSent: '验证码已发送到 {email}',
    backToHome: '返回首页',
    emailAlreadyRegistered: '该邮箱已注册，请直接登录或使用其他邮箱',
    
    // 授权错误
    sessionExpired: '登录已过期，请重新登录',
    loginRequired: '需要登录才能访问',
    unauthorized: '您没有权限访问此页面',
    loginAgain: '请重新登录',
    
    // 忘记密码相关
    backToLogin: '返回登录',
    emailVerification: '邮箱验证',
    resetPassword: '重置密码',
    getVerificationCode: '获取验证码',
    verify: '验证',
    enterRegisteredEmail: '请输入您的注册邮箱',
    codeHasBeenSent: '验证码已发送至 {email}',
    resendCode: '重新发送',
    codeValidTime: '验证码有效期为10分钟',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    passwordMismatch: '两次输入的密码不一致',
    resetCodeSent: '重置密码验证码已发送至 {email}',
    sendCodeFailed: '发送验证码失败，请稍后再试',
    emailNotRegistered: '该邮箱未注册',
    networkError: '网络错误，请检查您的连接',
    invalidOrExpiredCode: '验证码无效或已过期',
    codeVerified: '验证码验证成功',
    verificationFailed: '验证失败，请重试',
    passwordResetSuccess: '密码重置成功，正在跳转到登录页...',
    passwordResetFailed: '密码重置失败，请稍后再试',

    // CloakList 相关
    createNewCloak: '创建新斗篷',
    editCloak: '编辑斗篷',
    mode: '模式',
    allModes: '全部',
    cloakMode: '斗篷',
    fullOpenMode: '全开',
    auditMode: '审核',
    cloakName: '斗篷名称',
    shortLink: '短链接',
    realLink: '真实链接',
    auditLink: '审核链接',
    targetRegions: '目标地区',
    totalVisits: '总访问量',
    realLinkVisits: '真实链接访问量',
    auditLinkVisits: '审核链接访问量',
    createdDate: '创建日期',
    actions: '操作',
    searchPlaceholder: '请输入斗篷名称',
    totalRecords: '共 {0} 条记录',
    refreshList: '刷新列表',
    swipeToSeeMore: '向右滑动查看更多信息',
    copyLinkTip: '点击链接旁边的复制图标可以复制链接地址',
    noData: '暂无数据',
    noMatchingCloaks: '没有找到匹配的斗篷，请调整过滤条件。',
    noCloakData: '暂无斗篷数据。请点击"创建新斗篷"按钮添加一个。',
    linkCopied: '链接已复制到剪贴板',
    copyFailed: '复制失败，请手动复制',
    copyLink: '复制链接',
    
    // 编辑弹窗相关
    adPlatform: '投放平台',
    adPlatformHint: '可多选，选择您计划投放广告的平台',
    selectContinent: '选择洲',
    selectRegion: '请选择地区',
    loadingCountries: '加载国家列表...',
    noCountries: '该洲暂无国家数据',
    loadCountryFailed: '无法加载国家列表',
    processDataFailed: '处理数据失败，请稍后重试',
    cloakModeDesc: '只有指定地区的用户可以访问真实链接',
    fullOpenModeDesc: '所有用户都访问真实链接',
    auditModeDesc: '所有点击都会转向审核链接',
    selectAtLeastOneRegion: '请至少选择一个地区',
    enterValidUrl: '请输入有效的URL',
    customOption: '自定义',
    defaultOption: '默认',
    gamingCategory: '游戏类',
    marketingCategory: '活动营销',
    shopCategory: '商城',
    corporateCategory: '企业宣传',
    photographyCategory: '摄影展示',
    miniGamesCategory: '在线小游戏',
    financeCategory: '金融',
    toolCategory: '工具',
    
    // 确认弹窗
    confirmDelete: '确认删除',
    confirmDeletion: '确认删除',
    confirmDeleteMessage: '确定要删除斗篷 "{0}"吗？此操作无法撤销。',
    
    // 会员提示
    membershipRequired: '需要会员身份',
    membershipRequiredMessage: '您需要成为会员才能创建斗篷。请订阅套餐以解锁此功能。',
    viewPlans: '查看套餐',
    
    // 分页
    firstPage: '第一页',
    previousPage: '上一页',
    nextPage: '下一页',
    lastPage: '最后一页',
    previous: '上一页',
    next: '下一页',
    
    // 模式显示
    unknown: '未知',
    statusActive: '活跃',
    statusPaused: '暂停',
    statusFailed: '失败',
    
    // 错误和处理状态
    error: '错误',
    retry: '重试',
    processing: '处理中...',
    
    // 操作结果信息
    cloakCreated: '斗篷 "{0}" 创建成功！',
    cloakUpdated: '斗篷 "{0}" 更新成功！',
    cloakDeleted: '斗篷 "{0}" 删除成功',
    createCloakFailed: '创建斗篷失败，请稍后再试',

    // cloak operations messages
    updateCloakFailed: '更新斗篷失败，请稍后再试',
    deleteCloakFailed: '删除斗篷失败，请稍后再试',

    // CloakLogs 组件翻译
    search: '搜索',
    searchPlaceholder: '搜索斗篷名称、IP地址等',
    redirectTo: '重定向至',
    all: '全部',
    resetFilters: '重置筛选',
    noLogsFound: '未找到匹配的日志记录',
    tryAdjustingFilters: '请尝试调整搜索或筛选条件',
    failedToLoadLogs: '加载日志失败',
    time: '时间',
    ipAddress: 'IP地址',
    ipInfo: 'IP信息',
    country: '国家/地区',
    mode: '模式',
    deviceBrowser: '设备/浏览器',
    cloakName: '斗篷名称',
    cloakId: '超链ID',
    realLink: '真实链接',
    auditLink: '审核链接',
    totalVisits: '总访问量',
    realLinkVisits: '真实链接访问量',
    auditLinkVisits: '审核链接访问量',
    totalRecords: '总计',
    records: '条记录',
    displaying: '显示',
    failedToGetDetails: '获取详情失败',
    cloakDetails: '斗篷详情',
    loadingDetails: '加载详情...',
    close: '关闭',
    basicInfoOnly: '仅显示基本信息，无法获取完整斗篷详情',
    name: '名称',
    created: '创建时间',
    shortLink: '短链接',
    targetRegions: '目标地区',
    firstPage: '首页',
    nextPage: '下一页',
    lastPage: '末页',
    allow: '放行',
    block: '拦截',
    unknownCloak: '未知斗篷',
    unknownDevice: '未知设备',
    noLogs: '暂无日志数据',
    actionResult: '操作结果',
    copyLink: '复制链接',
    copied: '已复制',
    selectCloak: '选择斗篷',
    allCloaks: '全部斗篷',
    searchCloak: '搜索斗篷',
    searchCloakPlaceholder: '输入斗篷名称或ID搜索',
    searchOrSelectCloak: '搜索或选择斗篷',
    noCloaksFound: '未找到匹配的斗篷',
    searching: '搜索中...',
    
    // CloakPlans组件需要的翻译
    totalCalls: '总调用次数',
    times: '次',
    validity: '有效期',
    unitPrice: '单价',
    call: '次调用',
    renewPlan: '续费套餐',
    selectPlan: '选择套餐',
    currentPlanInfo: '当前套餐信息',
    currentPlan: '当前套餐',
    expiryDate: '到期时间',
    remainingUsage: '剩余使用次数',
    permanent: '永久',
    permanentMember: '永久会员',
    usedText: '已用 {used} / 共 {total}',
    days: '天',
    validityPeriod: '有效期',
    purchaseHistory: '套餐购买历史',
    calls: '次数',
    purchaseTime: '购买时间',
    active: '使用中',
    expired: '已到期',
    daysText: '天',
    notSubscribed: '您尚未订阅任何套餐',
    alreadySubscribed: '您已有订阅，无法订阅免费套餐',
    choosePlanText: '选择适合您需求的套餐以开始使用我们的服务。订阅后，您将获得更多功能和更高的使用限制。',
    planComparison: '套餐对比',
    paymentHistory: '支付历史',
    amount: '金额',
    status: '状态',
    submittedAt: '提交时间',
    updatedAt: '更新时间',
    updated: '更新时间',
    paymentId: '订单号',
    unknownTime: '未知时间',
    noPaymentRecords: '暂无支付记录',
    submittedSuccess: '提交成功',
    paymentSubmittedMessage: '您的支付信息已提交，请等待管理员审核。审核通过后，套餐将自动生效。',
    gotIt: '我知道了',
    unknownPlan: '未知套餐',
    enterCloakId: '请输入超链ID',
    paymentInformation: '支付信息',
    selectedPlanText: '您已选择 {planName} 套餐。请按照以下信息完成支付。',
    walletAddress: '钱包地址 (TRC20)',
    copy: '复制',
    walletAddressCopied: '钱包地址已复制到剪贴板',
    scanQrCode: '扫描二维码支付',
    walletQrCode: '钱包二维码',
    useUsdtTrc20: '请使用USDT-TRC20钱包扫码支付',
    paymentAmount: '支付金额',
    uploadPaymentScreenshot: '上传支付截图',
    chooseFile: '选择文件',
    noFileSelected: '未选择文件',
    paymentScreenshotPreview: '支付截图预览',
    noteOptional: '备注 (可选)',
    noteOptionalPlaceholder: '如有特殊要求，请在此说明',
    cancel: '取消',
    submitPaymentInfo: '提交支付信息',
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝',
    failedToLoadData: '加载数据失败，请稍后再试',
    retry: '重试',
    noPlanData: '暂无套餐数据',

    // 支付弹窗缺失补充
    submit: '提交',
    paymentSubmitted: '支付已提交',
    pleaseUploadPaymentScreenshot: '请上传支付截图',
    failedToSubmitPaymentInformation: '提交支付信息失败，请重试',

    // ShortLinkModal 弹窗
    cloakCreatedSuccess: '创建成功',
    cloakCreatedMessage: '您的斗篷已成功创建，这是跳转链接：',
    generatingLink: '正在生成链接...',
    linkCopiedSuccess: '✓ 已复制',
    copyLink: '复制',
    testLinkInNewTab: '→ 在新标签页中测试链接',
    complete: '完成',
    browserNotSupportCopy: '您的浏览器不支持自动复制，请手动复制链接',
    enterCloakName: '输入斗篷名称',

    // DashboardLayout 翻译
    adminDashboardTitle: '管理后台',
    lowCallsNotice: '⚠️ 温馨提示！套餐剩余使用次数不足 500 次，建议及时补充套餐，以免影响正常使用。',

    // AdminDashboard 翻译
    adminDashboard: '管理仪表盘',
    totalUsers: '用户总数',
    totalPayments: '支付记录',
    totalCloaks: '斗篷总数',
    viewAll: '查看全部',
    recentUsers: '最近注册用户',
    recentPayments: '最近支付记录',
    noUserData: '暂无用户数据',
    noPaymentData: '暂无支付记录',
    
    // 语言切换
    notifications: '通知',
    simplifiedChinese: '简体中文',
    english: 'English',
    user: '用户',
    
    // 侧边栏
    expandMenu: '展开菜单',
    collapseMenu: '收起菜单',
    goToHome: '返回首页',
  },
  en: {
    // General
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    chinese: '中文',
    english: 'English',
    swipeToSee: '← Swipe to see more →',
    brandName: 'MagicAudit',
    goToHome: 'Go to Home',
    
    // Page Titles
    dashboard: 'Admin Dashboard',
    userCenter: 'Admin Center',
    beta: 'Beta',
    
    // Sidebar Menu
    home: 'Home',
    cloak: 'Deep Sea',
    cloakList: 'Cloak List',
    cloakLogs: 'Cloak Logs',
    myPlans: 'My Plans',
    planPurchase: 'Buy Plans',

    // Plan Purchase Page
    purchaseSubtitle: 'Pay per real link visit, credits added instantly',
    recommended: 'Recommended',
    validPeriod: '',
    avgPrice: 'Avg',
    perCall: 'call',
    realLinkCalls: 'Real Link Visits',
    globalGeoTargeting: 'Global Geo-Targeting',
    basicGeoTargeting: 'Basic Geo-Targeting',
    uaInterception: 'UA Interception',
    accessLogDays: '{days}d Access Log',
    accessLogDaysUnlimited: 'Permanent Logs',
    unlimitedCloaks: 'Unlimited Cloaks',
    maxCloaksText: 'Up to {count} Cloaks',
    apiAccess: 'API Access',
    noApiAccess: '✗ API Access',
    unlimitedSubAccounts: 'Unlimited Sub-accounts + Support',
    subAccountsCount: '{count} Sub-accounts',
    noSubAccounts: '✗ Sub-accounts',
    buyNow: 'Buy Now',
    paymentMethods: 'Payment Methods:',
    creditCard: 'Credit Card / Stripe',
    bankTransfer: 'Bank Transfer',
    paymentNote: 'Note:',
    paymentDescription: ' Credits are added to your account immediately after purchase and deducted based on actual usage. Unused credits expire at the end of the validity period. No refunds.',
    loadPlansFailed: 'Failed to load plans',
    
    // Admin Menu
    adminPanel: 'Admin Panel',
    adminDashboard: 'Admin Dashboard',
    userManagement: 'User Management',
    paymentReview: 'Payment Review',
    planManagement: 'Plan Management',
    siteSettings: 'Site Settings',
    statistics: 'Statistics',
    
    // Admin Dashboard Stats
    userStats: 'User Statistics',
    paymentStats: 'Payment Statistics',
    planStats: 'Plan Statistics',
    cloakStats: 'Cloak Statistics',
    activeUsers: 'Active Users',
    memberUsers: 'Member Users',
    pendingPayments: 'Pending Payments',
    approvedPayments: 'Approved Payments',
    rejectedPayments: 'Rejected Payments',
    activePlans: 'Active Plans',
    recentUsers: 'Recent Users',
    recentPayments: 'Recent Payments',
    viewAll: 'View All',
    
    // User Management Interface
    userList: 'User List',
    addUser: 'Add User',
    addAdmin: 'Add Admin',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    userId: 'User ID',
    username: 'Username',
    email: 'Email',
    userRole: 'Role',
    status: 'Status',
    isMemberValid: 'Membership',
    membershipExpiry: 'Membership Expiry',
    userTotalCalls: 'Total API Calls',
    userRemainingCalls: 'Remaining API Calls',
    createdAt: 'Created At',
    lastLogin: 'Last Login',
    actions: 'Actions',
    search: 'Search',
    reset: 'Reset',
    filter: 'Filter',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    confirmDelete: 'Confirm Delete',
    deleteConfirmation: 'Are you sure you want to delete this user? This action cannot be undone.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    roleAdmin: 'Admin',
    roleUser: 'User',
    roleVip: 'VIP User',
    roleSuperAdmin: 'Super Admin',
    
    // 提升为管理员
    promoteToAdmin: 'Promote to Admin',
    confirmPromoteToAdmin: 'Confirm Promote to Admin',
    promote: 'Promote',
    createAdmin: 'Create Admin',
    activateSuccess: 'User activated successfully',
    activateFailed: 'Failed to activate user',
    deactivateFailed: 'Failed to deactivate user',
    confirmDeactivate: 'Confirm Deactivate User',
    deactivateConfirmation: 'Are you sure you want to deactivate user {0}? They will not be able to log in.',
    
    // Payment Review Interface
    paymentReview: 'Payment Review',
    paymentRecords: 'Payment Records',
    paymentDetails: 'Payment Details',
    orderId: 'Order ID',
    userId: 'User ID',
    planName: 'Plan Name',
    amount: 'Amount',
    totalCalls: 'Total Calls',
    validityDays: 'Validity',
    days: 'days',
    submittedAt: 'Submitted At',
    updatedAt: 'Updated At',
    updated: 'Updated At',
    paymentId: 'Order ID',
    approvePayment: 'Approve Payment',
    rejectPayment: 'Reject Payment',
    confirmApprove: 'Confirm Approval',
    confirmReject: 'Confirm Rejection',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    rejectReason: 'Rejection Reason',
    rejectReasonRequired: 'Please enter a rejection reason',
    enterRejectReason: 'Enter reason for rejection...',
    noRemark: 'No remarks',
    remark: 'Remarks',
    paymentScreenshot: 'Payment Screenshot',
    noScreenshot: 'No screenshot',
    dateFrom: 'From Date',
    dateTo: 'To Date',
    perPage: 'Per Page',
    noPayments: 'No payment records',
    unknownPlan: 'Unknown Plan',
    operationFailed: 'Operation failed, please try again',
    retry: 'Retry',
    details: 'Details',
    
    // 支付审核确认和结果提示
    approveConfirmationMessage: 'You are sure you want to approve this payment? The user\'s membership privileges will be activated.',
    rejectConfirmationMessage: 'Are you sure you want to reject this payment? Please ensure you have entered a rejection reason.',
    approveSuccess: 'Payment approved successfully',
    rejectSuccess: 'Payment rejected successfully',
    approveFailure: 'Failed to approve payment',
    rejectFailure: 'Failed to reject payment',
    
    requiredField: 'This field is required',
    passwordTooShort: 'Password must be at least 8 characters',
    invalidEmail: 'Please enter a valid email address',
    saveChanges: 'Save Changes',
    createUser: 'Create User',
    delete: 'Delete',
    edit: 'Edit',
    processing: 'Processing...',
    leaveEmptyToKeep: 'Leave empty to keep unchanged',
    noUsers: 'No users found',

    // User Plan Detail Modal
    planUsageDetail: 'Plan Usage Detail',
    currentPlanName: 'Current Plan',
    memberStatus: 'Member Status',
    memberValid: 'Valid',
    memberExpired: 'Expired',
    notMember: 'Not a Member',
    membershipStartDate: 'Start Date',
    membershipExpiryDate: 'Expiry Date',
    remainingDays: 'Days Left',
    daysUnit: 'days',
    totalCallsLabel: 'Total Calls',
    remainingCallsLabel: 'Remaining Calls',
    usedCallsLabel: 'Used Calls',
    usageRate: 'Usage Rate',
    adjustPlan: 'Adjust Plan',
    adjustCalls: 'Adjust Calls',
    adjustDays: 'Adjust Days',
    adjustCallsPlaceholder: 'Positive to add, negative to subtract',
    adjustDaysPlaceholder: 'Positive to extend, negative to shorten',
    applyAdjustment: 'Apply Adjustment',
    adjustSuccess: 'Adjustment applied successfully',
    adjustFailed: 'Adjustment failed',
    paymentHistory: 'Payment History',
    noPaymentHistory: 'No payment records',
    paymentAmount: 'Amount',
    paymentStatus: 'Payment Status',
    paymentDate: 'Payment Date',
    close: 'Close',
    timesUnit: 'times',
    noPlanAssigned: 'No Plan Assigned',
    notAvailable: 'N/A',
    expired: 'Expired',
    callsUsageProgress: 'Calls Usage Progress',
    adjustRequiresMember: 'This user is not a member. Please approve a payment to activate membership first.',

    // Plan Management Interface
    planManagement: 'Plan Management',
    planList: 'Plan List',
    planId: 'Plan ID',
    chineseName: 'Chinese Name',
    englishName: 'English Name',
    planNameChinese: 'Plan Name (Chinese)',
    enterPlanNameChinese: 'Enter Chinese plan name',
    planNameEnglish: 'Plan Name (English)',
    enterPlanNameEnglish: 'Enter English plan name',
    planSavedSuccess: 'Plan saved successfully',
    price: 'Price',
    addPlan: 'Add Plan',
    editPlan: 'Edit Plan',
    createPlan: 'Create Plan',
    save: 'Save',
    mustBePositive: 'Must be a positive number',
    enterPlanName: 'Enter plan name',
    deletePlanConfirmation: 'Are you sure you want to delete this plan? This action cannot be undone.',
    noPlans: 'No plans found',
    
    // Random Period
    randomPeriod: 'Random Period',
    enableRandomPeriod: 'Enable Random Period',
    validityDaysMin: 'Min Days',
    validityDaysMax: 'Max Days',
    randomPeriodRange: 'Random Period Range',
    specifyValidityDays: 'Specify Validity Days',
    validityDaysPlaceholder: 'Enter validity days',
    randomPeriodHint: 'This plan has random period enabled. You need to specify validity days when reviewing.',
    validityDaysRangeHint: 'Range: {min}-{max} days',
    adminSpecifiedDays: 'Admin Specified Days',
    randomPeriodLabel: 'Random Period',
    fixedPeriodLabel: 'Fixed Period',
    minDaysRequired: 'Min days is required',
    maxDaysRequired: 'Max days is required',
    minMaxError: 'Min days cannot be greater than max days',
    validityDaysRequired: 'Please specify validity days',
    validityDaysOutOfRange: 'Validity days must be between {min}-{max} days',
    unlimitedCalls: 'Unlimited Calls',
    enableUnlimitedCalls: 'Unlimited API Calls',
    unlimited: 'Unlimited',
    setUnlimitedCalls: 'Unlimited Calls',
    confirmSetUnlimitedCalls: 'Confirm Unlimited Calls',
    setUnlimitedCallsConfirmation: 'Are you sure you want to set user {0} to unlimited calls? They will no longer be limited by call count.',
    unlimitedCallsSetSuccess: 'Unlimited calls set successfully',
    unlimitedCallsSetFailed: 'Failed to set unlimited calls',
    cancelUnlimitedCalls: 'Remove Unlimited',
    
    // Plan Status
    planStatus: 'Plan Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    enablePlan: 'Enable',
    disablePlan: 'Disable',
    
    // User Menu
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    user: 'User',
    
    // Card Titles
    cloakOverview: 'Cloak Overview',
    logRecords: 'Log Records',
    mySubscription: 'My Subscription',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    
    // Stat Labels
    totalCloaks: 'Total Cloaks',
    activeCloaks: 'Active Cloaks',
    totalLogs: 'Total Logs',
    currentPlan: 'Current Plan',
    expiryDate: 'Expiry Date',
    noPlan: 'No Plan',
    
    // Activity Table
    time: 'Time',
    action: 'Action',
    status: 'Status',
    details: 'Details',
    success: 'Success',
    noActivity: 'No activity records',
    
    // Buttons
    createNewCloak: 'Create New Cloak',
    viewAllLogs: 'View All Logs',
    upgradePlan: 'Upgrade Plan',
    
    // Copyright
    copyright: '© {year} 奇迹秒审',
    tagline: 'Precision Advertising System',

    // Dashboard Home
    dashboardSubtitle: 'Welcome back, check your data overview',
    totalCloaksSub: 'Today +{0}',
    totalLogsSub: 'Total access logs',
    recentCloaks: 'Recent Cloaks',
    mode: 'Mode',
    name: 'Name',
    shortLink: 'Short Link',
    targetUrl: 'Target URL',
    visits: 'Visits',
    created: 'Created',
    createdAt: 'Created',
    noRecentCloaks: 'No cloak data available',
    copyLink: 'Copy Link',
    loading: 'Loading...',
    error: 'Error',
    reload: 'Reload',
    remainingCalls: 'Remaining Calls',
    unlimited: 'Unlimited',
    viewAllCloaks: 'View All Cloaks →',
    linkCopied: 'Link copied to clipboard',
    copyFailed: 'Copy failed',
    copyFailedManual: 'Copy failed, please copy manually',
    premiumMember: 'Premium Member',
    freeUser: 'Free User',
    failedToLoadData: 'Failed to load data',
    failedToLoadDataRetry: 'Failed to load data, please try again later',

    // Login & Registration Page
    login: 'Login',
    register: 'Register',
    emailAddress: 'Email Address',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    verificationCode: 'Verification Code',
    sendCode: 'Send Code',
    resendCodeIn: 'Resend in {seconds}s',
    passwordPlaceholder: 'Enter your password',
    passwordRule: 'Min. 8 chars with letters and numbers',
    codePlaceholder: 'Enter 6-digit code',
    sending: 'Sending',
    processing: 'Processing...',
    agreeTerms: 'I have read and agree to the',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    welcomeBack: 'Welcome Back',
    loginToContinue: 'Login to continue to your account',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    createAccount: 'Create Account',
    registerToContinue: 'Register to start using our services',
    switchToLogin: 'Back to Login',
    switchToRegister: 'Register Now',
    requiredEmail: 'Please enter your email address',
    requiredPassword: 'Please enter your password',
    invalidPassword: 'Password must be at least 8 characters with letters and numbers',
    requiredCode: 'Please enter verification code',
    invalidCode: 'Verification code should be 6 digits',
    agreeTermsError: 'Please agree to the terms of service',
    resetPassword: 'Reset Password',
    resetPasswordSent: 'Password reset link has been sent to {email}',
    verificationSent: 'Verification code has been sent to {email}',
    backToHome: 'Back to Home',
    emailAlreadyRegistered: 'This email is already registered. Please log in or use another email.',
    
    // Authorization Errors
    sessionExpired: 'Your session has expired, please login again',
    loginRequired: 'Login required to access this page',
    unauthorized: 'You are not authorized to view this page',
    loginAgain: 'Please login again',
    
    // Forgot Password
    backToLogin: 'Back to Login',
    emailVerification: 'Email Verification',
    resetPassword: 'Reset Password',
    getVerificationCode: 'Get Code',
    verify: 'Verify',
    enterRegisteredEmail: 'Please enter your registered email',
    codeHasBeenSent: 'Verification code has been sent to {email}',
    resendCode: 'Resend Code',
    codeValidTime: 'Verification code is valid for 10 minutes',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Please enter new password again',
    passwordMismatch: 'Passwords do not match',
    resetCodeSent: 'Password reset code has been sent to {email}',
    sendCodeFailed: 'Failed to send code, please try again later',
    emailNotRegistered: 'This email is not registered',
    networkError: 'Network error, please check your connection',
    invalidOrExpiredCode: 'Invalid or expired verification code',
    codeVerified: 'Code verified successfully',
    verificationFailed: 'Verification failed, please try again',
    passwordResetSuccess: 'Password reset successful, redirecting to login...',
    passwordResetFailed: 'Password reset failed, please try again later',

    // CloakList related
    createNewCloak: 'Create New Cloak',
    editCloak: 'Edit Cloak',
    mode: 'Mode',
    allModes: 'All',
    cloakMode: 'Cloak',
    fullOpenMode: 'Full Open',
    auditMode: 'Audit',
    cloakName: 'Cloak Name',
    shortLink: 'Short Link',
    realLink: 'Real Link',
    auditLink: 'Audit Link',
    targetRegions: 'Regions',
    totalVisits: 'Total Visits',
    realLinkVisits: 'Real Link Visits',
    auditLinkVisits: 'Audit Link Visits',
    createdDate: 'Created Date',
    actions: 'Actions',
    searchPlaceholder: 'Enter cloak name',
    totalRecords: '{0} records total',
    refreshList: 'Refresh List',
    swipeToSeeMore: 'Swipe right to see more information',
    copyLinkTip: 'Click the copy icon next to a link to copy the link address',
    noData: 'No data available',
    noMatchingCloaks: 'No matching cloaks found, please try adjusting your filter criteria.',
    noCloakData: 'No cloak data available. Please click "Create New Cloak" button to add one.',
    linkCopied: 'Link copied to clipboard',
    copyFailed: 'Copy failed, please copy manually',
    copyLink: 'Copy Link',
    
    // Edit modal related
    adPlatform: 'Ad Platform',
    adPlatformHint: 'Multi-select, choose your planned ad platforms',
    selectContinent: 'Select Continent',
    selectRegion: 'Select Region',
    loadingCountries: 'Loading countries...',
    noCountries: 'No country data for this continent',
    loadCountryFailed: 'Failed to load country list',
    processDataFailed: 'Failed to process data, please try again later',
    cloakModeDesc: 'Only users from specified regions can access the real link',
    fullOpenModeDesc: 'All users access the real link',
    auditModeDesc: 'All clicks redirect to the audit link',
    selectAtLeastOneRegion: 'Please select at least one region',
    enterValidUrl: 'Please enter a valid URL',
    customOption: 'Custom',
    defaultOption: 'Default',
    gamingCategory: 'Gaming',
    marketingCategory: 'Marketing',
    shopCategory: 'Shop',
    corporateCategory: 'Corporate',
    photographyCategory: 'Photography',
    miniGamesCategory: 'Mini Games',
    financeCategory: 'Finance',
    toolCategory: 'Tool',
    
    // Confirmation modals
    confirmDelete: 'Confirm Deletion',
    confirmDeletion: 'Confirm Deletion',
    confirmDeleteMessage: 'Are you sure you want to delete the cloak "{0}"? This action cannot be undone.',
    
    // Membership prompts
    membershipRequired: 'Membership Required',
    membershipRequiredMessage: 'You need to be a member to create a cloak. Please subscribe to a plan to unlock this feature.',
    viewPlans: 'View Plans',
    
    // Pagination
    firstPage: 'First page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    lastPage: 'Last page',
    previous: 'Previous',
    next: 'Next',
    
    // Mode display
    unknown: 'Unknown',
    statusActive: 'Active',
    statusPaused: 'Paused',
    statusFailed: 'Failed',
    
    // Errors and processing states
    error: 'Error',
    retry: 'Retry',
    processing: 'Processing...',
    
    // Action result messages
    cloakCreated: 'Cloak "{0}" created successfully!',
    cloakUpdated: 'Cloak "{0}" updated successfully!',
    cloakDeleted: 'Cloak "{0}" deleted successfully',
    createCloakFailed: 'Failed to create cloak, please try again later',

    // cloak operations messages
    updateCloakFailed: 'Failed to update cloak, please try again later',
    deleteCloakFailed: 'Failed to delete cloak, please try again later',

    // CloakLogs 组件翻译
    search: 'Search',
    searchPlaceholder: 'Search cloak name, IP address, etc.',
    redirectTo: 'Redirect To',
    all: 'All',
    resetFilters: 'Reset Filters',
    noLogsFound: 'No logs found matching your criteria',
    tryAdjustingFilters: 'Try adjusting your search or filter settings',
    failedToLoadLogs: 'Failed to load logs',
    time: 'Time',
    ipAddress: 'IP Address',
    country: 'Country',
    mode: 'Mode',
    deviceBrowser: 'Device/Browser',
    cloakName: 'Cloak Name',
    realLink: 'Real Link',
    auditLink: 'Audit Link',
    totalVisits: 'Total Visits',
    realLinkVisits: 'Real Link Visits',
    auditLinkVisits: 'Audit Link Visits',
    totalRecords: 'Total',
    records: 'records',
    displaying: 'displaying',
    failedToGetDetails: 'Failed to get details',
    cloakDetails: 'Cloak Details',
    loadingDetails: 'Loading details...',
    close: 'Close',
    basicInfoOnly: 'Only showing basic information, unable to get complete cloak details',
    name: 'Name',
    created: 'Created',
    shortLink: 'Short Link',
    targetRegions: 'Regions',
    firstPage: 'First Page',
    nextPage: 'Next Page',
    lastPage: 'Last Page',
    allow: 'Allow',
    block: 'Block',
    unknownCloak: 'Unknown Cloak',
    unknownDevice: 'Unknown Device',
    noLogs: 'No logs available',
    actionResult: 'Action Result',
    copied: 'Copied',
    selectCloak: 'Select Cloak',
    allCloaks: 'All Cloaks',
    searchCloak: 'Search Cloak',
    searchCloakPlaceholder: 'Enter cloak name or ID to search',
    searchOrSelectCloak: 'Search or select cloak',
    noCloaksFound: 'No matching cloaks found',
    searching: 'Searching...',

    // CloakPlans translations
    totalCalls: 'Total calls',
    times: 'times',
    validity: 'Validity',
    unitPrice: 'Unit price',
    call: 'call',
    renewPlan: 'Renew Plan',
    selectPlan: 'Select Plan',
    currentPlanInfo: 'Current Plan Information',
    currentPlan: 'Current Plan',
    expiryDate: 'Expiry Date',
    remainingUsage: 'Remaining Usage',
    permanent: 'Permanent',
    permanentMember: 'Permanent Member',
    usedText: 'Used {used} / Total {total}',
    days: 'days',
    validityPeriod: 'Validity Period',
    purchaseHistory: 'Purchase History',
    calls: 'Calls',
    purchaseTime: 'Purchase Time',
    active: 'Active',
    expired: 'Expired',
    daysText: ' days',
    notSubscribed: 'You are not subscribed to any plan',
    alreadySubscribed: 'You already have a subscription and cannot subscribe to a free plan',
    choosePlanText: 'Choose a plan that suits your needs to start using our services. After subscribing, you will gain access to more features and higher usage limits.',
    planComparison: 'Plan Comparison',
    paymentHistory: 'Payment History',
    amount: 'Amount',
    status: 'Status',
    submittedAt: 'Submitted At',
    updatedAt: 'Updated At',
    updated: 'Updated At',
    paymentId: 'Order ID',
    unknownTime: 'Unknown time',
    noPaymentRecords: 'No payment records',
    paymentInformation: 'Payment Information',
    selectedPlanText: 'You have selected {planName} plan. Please complete payment according to the following information.',
    walletAddress: 'Wallet Address (TRC20)',
    copy: 'Copy',
    walletAddressCopied: 'Wallet address copied to clipboard',
    scanQrCode: 'Scan QR code to make payment',
    walletQrCode: 'Wallet QR Code',
    useUsdtTrc20: 'Please use USDT-TRC20 wallet to scan and pay',
    paymentAmount: 'Payment Amount',
    uploadPaymentScreenshot: 'Upload Payment Screenshot',
    chooseFile: 'Choose File',
    noFileSelected: 'No file selected',
    paymentScreenshotPreview: 'Payment Screenshot Preview',
    noteOptional: 'Note (Optional)',
    noteOptionalPlaceholder: 'If you have any special requirements, please specify here',
    cancel: 'Cancel',
    submitPaymentInfo: 'Submit Payment Information',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    failedToLoadData: 'Failed to load data, please try again later',
    retry: 'Retry',
    noPlanData: 'No plan data available',
    submittedSuccess: 'Submitted Successfully',

    // Payment modal missing keys
    submit: 'Submit',
    paymentSubmitted: 'Payment Submitted',
    pleaseUploadPaymentScreenshot: 'Please upload payment screenshot',
    failedToSubmitPaymentInformation: 'Failed to submit payment information, please try again',
    paymentSubmittedMessage: 'Your payment information has been submitted. Please wait for admin review. Once approved, the plan will take effect automatically.',
    gotIt: 'Got it',
    unknownPlan: 'Unknown Plan',
    enterCloakId: 'Enter cloak ID',

    // ShortLinkModal dialog
    cloakCreatedSuccess: 'Created Successfully',
    cloakCreatedMessage: 'Your cloak has been created successfully. Here is the redirect link:',
    generatingLink: 'Generating link...',
    linkCopiedSuccess: '✓ Copied',
    copyLink: 'Copy',
    testLinkInNewTab: '→ Test link in new tab',
    complete: 'Complete',
    browserNotSupportCopy: 'Your browser does not support auto-copy, please copy manually',
    enterCloakName: 'Enter cloak name',

    // DashboardLayout translations
    adminDashboardTitle: 'Admin Dashboard',
    lowCallsNotice: '⚠️ Notice: Your plan has less than 500 calls remaining. Please renew your plan to avoid service interruption.',

    // AdminDashboard translations
    adminDashboard: 'Admin Dashboard',
    totalUsers: 'Total Users',
    totalPayments: 'Payment Records',
    totalCloaks: 'Total Cloaks',
    cloakStats: 'Cloak Statistics',
    viewAll: 'View All',
    recentUsers: 'Recent Users',
    recentPayments: 'Recent Payments',
    userId: 'User ID',
    email: 'Email',
    role: 'Role',
    registrationTime: 'Registration Time',
    noUserData: 'No user data available',
    orderId: 'Order ID',
    userEmail: 'User Email',
    amount: 'Amount',
    status: 'Status',
    noPaymentData: 'No payment data available',
    
    // Language switch
    notifications: 'Notifications',
    simplifiedChinese: '简体中文',
    english: 'English',
    user: 'User',
    
    // Sidebar
    expandMenu: 'Expand Menu',
    collapseMenu: 'Collapse Menu',
    goToHome: 'Go to Home',
  }
};

// 获取翻译函数
export const getTranslation = (language) => {
  return (key, replacements = {}) => {
    // 获取当前语言的翻译，如果没有则使用中文作为后备
    const langDict = translations[language] || translations.zh;
    let text = langDict[key] || key;
    
    // 替换占位符，例如 {year} 替换为实际年份
    Object.keys(replacements).forEach(key => {
      text = text.replace(`{${key}}`, replacements[key]);
    });
    
    return text;
  };
}; 